import { useEffect } from 'react';

const useRefresh = (history: any, path: string, resetRoute: string = '/'): any => {
  let handler: any;

  const refresh = (): any => {
    history.push(resetRoute);
    handler = setTimeout((): any => history.push(path), 10);
  };

  useEffect((): any => {
    return (): any => handler && clearTimeout(handler);
  }, [handler]);

  return refresh;
};
export default useRefresh;
